export default {
  siteId: "5",
  siteName: "it",
  lang: "Italian",
  langCode: "it-IT",
  site: "it",
  MediaReward: "Condividi foto o video per sbloccare ricompense speciali.",
  MediaType: "I tipi di file supportati includono JPEG, JPG, PNG o MP4.",
  RewardQa:
    "Completa tutte le domande di seguito per ottenere premi aggiuntivi.",
  MoreQa: "Clicca per compilare ulteriori domande.",
  RewardsToast:
    "La tua ricompensa è stata accreditata con successo sul tuo account.",
  subscribe1:
    "Ti sei cancellato con successo dai messaggi di marketing di Cupshe IT.",
  subscribe2: "Non volevi disiscriverti?",
  subscribe3: "RICOSCRIVITI",
  subscribe4:
    "Sei stato reiscritto con successo ai messaggi di marketing di Cupshe IT.",
  "You're already on the list!": "Sei già in lista! :)",
  "Oops, there was a hiccup!Please try again.":
    "Spiacenti, si è verificato un problema! Riprova.",
  unsubscribe: "annulla i'iscrizione",
  continuesubscribe: "CONTINUA AD ABBONARTI",
  trustsubscribe:
    "Grazie per la vostra fiducia, vi forniremo servizi migliori e prodotti più convenienti.",
  mailContact:
    'Contattare il <a href="https://it.cupshe.com/pages/contact-us" class="contact_link">servizio clienti</a> per assistenza.',
  policyText:
    "*Nota bene: dopo aver annullato l'iscrizione, potresti ricevere e-mail contenenti informazioni contrattuali relative a futuri acquisti online (conferme d'ordine, notifiche di spedizione, notifiche di rimborso e così via).",
};
